function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudronLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M384.5 30.9c28 16.1 128.1 193.5 128.1 225.8s-100 209.7-128.1 225.8-228.1 16.1-256.2 0c-28-17.4-128-194.8-128-227 0-32.3 100-209.7 128.1-225.8 28-16.2 228-14.9 256.1 1.2",
    style: {
      fill: "#03a9f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.5 228.7c17.1 0 31.7-13.6 31.7-32.3v-53.3c0-17.4-13.4-32.3-31.7-32.3h-51.2c-18.3 0-32.9 14.9-32.9 32.3v54.6c-2-.4-4-.6-6.1-.6h-52.4c-18.3 0-31.7 14.9-31.7 32.3v53.3c0 17.4 13.4 32.3 31.7 32.3h52.4c2.1 0 4.1-.2 6.1-.6v53.3c0 17.4 13.4 32.3 31.7 32.3h52.4c17.1 0 31.7-13.6 31.7-32.3v-53.3c0-17.4-13.4-32.3-31.7-32.3h-51.2c-2.5 0-5 .3-7.3.8v-54.7c2 .4 4 .6 6.1.6h52.4z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudronLogo);
export default __webpack_public_path__ + "static/media/cloudron-logo.54c340accf441408be910668a6dbd4fa.svg";
export { ForwardRef as ReactComponent };